import React, {Component} from 'react';
import PropTypes from 'prop-types';

import 'style/components/ui/widget.scss';

class Widget extends Component {

    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        title: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        head: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        footer: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        className: PropTypes.string
    };
    static defaultProps = {
        className: ''
    };

    render() {
        const {head, footer, title, children, className, style, styleBody} = this.props,
            headWidget = head ? (
                <div className="widget-title-right">
                    {head}
                </div>
            ) : null,
            footerWidget = footer ? (
                <div className="widget-footer">
                    <div className="text-muted mb-0">{footer}</div>
                </div>
            ) : null,
            titleWidget = title ? (
                <div className="widget-header">
                    <h3 className="widget-title">{title}</h3>
                    {headWidget}
                </div>
            ) : null;

        const _getClassName = () => `${className} widget`;

        return (
            <div id={this.props.id} className={_getClassName()} style={style}>
                {titleWidget}
                <div className="widget-body" style={styleBody}>
                    {children}
                </div>
                {footerWidget}
            </div>
        );
    }
}

export default Widget;



// WEBPACK FOOTER //
// ./src/components/ui/layout/panel/Widget.jsx